import mdl from 'material-design-lite';
import Masonry from 'masonry-layout';
import noUiSlider from 'no-ui-slider';
import imagesLoaded from 'imagesloaded';

// Put jQuery everywhere
window.$ = window.jQuery = require('jquery');

// Load jQuery plugins
require('trunk8');
require('owl.carousel');
require('jquery-ui/dist/jquery-ui'); // attempting to include for tab so they don't have to import it separately
require('jquery-autocomplete');

const $ = window.$;

const loggedIn = () => document.getElementsByClassName('user-menu__saved').length > 0;

export {
  mdl,
  Masonry,
  noUiSlider,
  imagesLoaded,
  $,
  loggedIn
};
